window.RefreshCartPage = () => {
    console.log("call window.RefreshCartPage()");
    document.dispatchEvent(
        new CustomEvent('cart:refresh', {
        detail: {
            open: false,
        },
        })
    );
  
};

$(document).on('click', '.drawer__close-btn', function () {
   document.querySelector('cart-drawer').hide(); 
});



var validateFreeItems = (cart) => {
    console.log("Call validateFreeItem", cart);
    if (Shopify.settings.afwp_enable === "true" && Shopify.settings.afwp_product != "") {
        if (cart) {
            if (!cart.item_count) {
                 if (window.location.pathname.includes('/cart')) {
                    window.RefreshCartPagePage();
                } else {
                    window.RefreshCartPage();
                }
                return;
            }
            var afwp_threshold_1 = Shopify.settings.afwp_threshold_1 || Infinity,
                afwp_threshold_2 = Shopify.settings.afwp_threshold_2 || Infinity,
                afwp_threshold_3 = Shopify.settings.afwp_threshold_3 || Infinity,
                afwp_threshold_4 = Shopify.settings.afwp_threshold_4 || Infinity,
                afwp_avail_qty_1 = Shopify.settings.afwp_avail_qty_1,
                afwp_avail_qty_2 = Shopify.settings.afwp_avail_qty_2,
                afwp_avail_qty_3 = Shopify.settings.afwp_avail_qty_3,
                afwp_avail_qty_4 = Shopify.settings.afwp_avail_qty_4,
                afwp_id = Shopify.settings.afwp_product,
                cart_total_price,
                threshold_qty = 0;
            if (Shopify.afwp_variants.id.length) {
                cart_total_price = getCartValueById(cart, Shopify.afwp_variants.id, "price");
            } else {
                cart_total_price = cart.total_price;
            }
            console.log(cart_total_price);
            if (
                cart_total_price > afwp_threshold_1 &&
                cart_total_price < afwp_threshold_2 &&
                cart_total_price < afwp_threshold_3 &&
                cart_total_price < afwp_threshold_4
            ) {
                threshold_qty = afwp_avail_qty_1;
            } else if (
                cart_total_price > afwp_threshold_1 &&
                cart_total_price > afwp_threshold_2 &&
                cart_total_price < afwp_threshold_3 &&
                cart_total_price < afwp_threshold_4
            ) {
                threshold_qty = afwp_avail_qty_2;
            } else if (
                cart_total_price > afwp_threshold_1 &&
                cart_total_price > afwp_threshold_2 &&
                cart_total_price > afwp_threshold_3 &&
                cart_total_price < afwp_threshold_4
            ) {
                threshold_qty = afwp_avail_qty_3;
            } else if (
                cart_total_price > afwp_threshold_1 &&
                cart_total_price > afwp_threshold_2 &&
                cart_total_price > afwp_threshold_3 &&
                cart_total_price > afwp_threshold_4
            ) {
                threshold_qty = afwp_avail_qty_4;
            }
            var giftKeyFromCart = [],
                gift_count = 0;
            cart.items.forEach((item) => {
                try {
                    if (item.properties.__type != null) {
                        if (item.properties.__type === "free gift") {
                            gift_count = gift_count + item.quantity;
                        }
                    }
                } catch (err) {
                    console.log(err);
                }
            });
            var checkItem = checkItemInCart(cart);
            console.log(checkItem);
            if (threshold_qty > 0 && checkItem) {
                if (gift_count > 0) {
                    cart.items.forEach((item) => {
                        if (item.properties.__type != null) {
                            if (item.properties.__type === "free gift") {
                                var quantity = threshold_qty,
                                    item_key = item.key;
                                giftKeyFromCart.push(item_key + "|" + quantity);
                            }
                        }
                    });
                    removeSampleItemss(giftKeyFromCart);
                } else {
                    var data = { quantity: threshold_qty, id: afwp_id, properties: { __type: "free gift" } };
                    addItemToCart(data);
                }
            } else {
                if (cart.items.length) {
                    cart.items.forEach((item) => {
                        if (item.properties.__type != null) {
                            if (item.properties.__type === "free gift") {
                                var quantity = 0,
                                    item_key = item.key;
                                giftKeyFromCart.push(item_key + "|" + quantity);
                            }
                        }
                    });
                    removeSampleItemss(giftKeyFromCart);
                }
            }
            return "success";
        }
        setTimeout(function () {
            $.ajax({ type: "GET", url: "/cart.js", dataType: "json" })
                .done(function (cart, textStatus, jqXHR) {
                    var afwp_threshold_1 = Shopify.settings.afwp_threshold_1 || Infinity,
                        afwp_threshold_2 = Shopify.settings.afwp_threshold_2 || Infinity,
                        afwp_threshold_3 = Shopify.settings.afwp_threshold_3 || Infinity,
                        afwp_threshold_4 = Shopify.settings.afwp_threshold_4 || Infinity,
                        afwp_avail_qty_1 = Shopify.settings.afwp_avail_qty_1,
                        afwp_avail_qty_2 = Shopify.settings.afwp_avail_qty_2,
                        afwp_avail_qty_3 = Shopify.settings.afwp_avail_qty_3,
                        afwp_avail_qty_4 = Shopify.settings.afwp_avail_qty_4,
                        afwp_id = Shopify.settings.afwp_product,
                        cart_total_price,
                        threshold_qty = 0;
                    if (Shopify.afwp_variants.id.length) {
                        cart_total_price = getCartValueById(cart, Shopify.afwp_variants.id, "price");
                    } else {
                        cart_total_price = cart.total_price;
                    }
                    console.log(cart_total_price);
                    if (
                        cart_total_price > afwp_threshold_1 &&
                        cart_total_price < afwp_threshold_2 &&
                        cart_total_price < afwp_threshold_3 &&
                        cart_total_price < afwp_threshold_4
                    ) {
                        threshold_qty = afwp_avail_qty_1;
                    } else if (
                        cart_total_price > afwp_threshold_1 &&
                        cart_total_price > afwp_threshold_2 &&
                        cart_total_price < afwp_threshold_3 &&
                        cart_total_price < afwp_threshold_4
                    ) {
                        threshold_qty = afwp_avail_qty_2;
                    } else if (
                        cart_total_price > afwp_threshold_1 &&
                        cart_total_price > afwp_threshold_2 &&
                        cart_total_price > afwp_threshold_3 &&
                        cart_total_price < afwp_threshold_4
                    ) {
                        threshold_qty = afwp_avail_qty_3;
                    } else if (
                        cart_total_price > afwp_threshold_1 &&
                        cart_total_price > afwp_threshold_2 &&
                        cart_total_price > afwp_threshold_3 &&
                        cart_total_price > afwp_threshold_4
                    ) {
                        threshold_qty = afwp_avail_qty_4;
                    }
                    var giftKeyFromCart = [],
                        gift_count = 0;
                    cart.items.forEach((item) => {
                        try {
                            if (item.properties.__type != null) {
                                if (item.properties.__type === "free gift") {
                                    gift_count = gift_count + item.quantity;
                                }
                            }
                        } catch (err) {
                            console.log(err);
                        }
                    });
                    var checkItem = checkItemInCart(cart);
                    console.log(checkItem);
                    if (threshold_qty > 0 && checkItem) {
                        if (gift_count > 0) {
                            cart.items.forEach((item) => {
                                if (item.properties.__type != null) {
                                    if (item.properties.__type === "free gift") {
                                        var quantity = threshold_qty,
                                            item_key = item.key;
                                        giftKeyFromCart.push(item_key + "|" + quantity);
                                    }
                                }
                            });
                            removeSampleItemss(giftKeyFromCart);
                        } else {
                            var data = { quantity: threshold_qty, id: afwp_id, properties: { __type: "free gift" } };
                            addItemToCart(data);
                        }
                    } else {
                        if (cart.items.length) {
                            cart.items.forEach((item) => {
                                if (item.properties.__type != null) {
                                    if (item.properties.__type === "free gift") {
                                        var quantity = 0,
                                            item_key = item.key;
                                        giftKeyFromCart.push(item_key + "|" + quantity);
                                    }
                                }
                            });
                            removeSampleItemss(giftKeyFromCart);
                        }
                    }
                    return "success";
                })
                .fail(function (jqXHR, textStatus) {});
        }, 0);
    } else {
        console.log("fsdds");
         if (window.location.pathname.includes('/cart')) {
           window.RefreshCartPagePage();
        } else {
            window.RefreshCartPage();
        }
    }
};
function addItemToCart(data) {
    $.ajax({
        type: "POST",
        url: "/cart/add.js",
        dataType: "json",
        data: data,
        success: function (data) {
             if (window.location.pathname.includes('/cart')) {
                window.RefreshCartPagePage();
            } else {
                window.RefreshCartPage();
                setTimeout(function () {
                    $('[name="checkout"]').attr("disabled", !1);
                }, 2000);
            }
        },
        error: function (status) {
            console.log(status);
            console.log($.parseJSON(status.responseText).description);
            $(".selectFreeGift").prop("disabled", !1);
        },
    });
}
function checkItemInCart(cart) {
    let flags = { afwp_variants: !1, smple_product: !1, travel_size_product: !1 };
    if (Shopify.afwp_variants.id && Shopify.afwp_variants.id.length) {
        flags.afwp_variants = cart.items.some((line_item) => {
            return Shopify.afwp_variants.id.includes(line_item.id.toString());
        });
    }
    if (Shopify.settings.smple_product && Shopify.settings.smple_product.length) {
        flags.smple_product = cart.items.some((line_item) => {
            console.log("smple_product");
            return Shopify.settings.smple_product.includes(line_item.id.toString());
        });
    }
    if (Shopify.settings.travel_size_product && Shopify.settings.travel_size_product.length) {
        flags.travel_size_product = cart.items.some((line_item) => {
            console.log("travel_size_product");
            return Shopify.settings.travel_size_product.includes(line_item.id.toString());
        });
    }
    return flags;
}
function getCartValueById(cart, ids = [], type = "") {
    if (type != "") {
        var value = 0;
        cart.items.forEach((line_item) => {
            var id = line_item.id.toString();
            if (ids.indexOf(id) != -1) {
                switch (type) {
                    case "price":
                        value = value + line_item.line_price;
                        break;
                    case "quantity":
                        value = value + line_item.quantity;
                        break;
                }
            }
        });
        return value;
    }
}
window.addItemInCart = () => {
    var free_sample_id = Shopify.settings.smple_product,
        free_travel_id = Shopify.settings.travel_size_product,
        free_sample_price = Shopify.settings.free_sample_price,
        free_travel_price = Shopify.settings.free_travel_price;
    if ($("body").hasClass("adding")) {
        console.log("in progesssing......");
        setTimeout(function () {
            $("body").removeClass("adding");
        }, 2000);
        return;
    }
    $.ajax({ type: "GET", url: "/cart.js", dataType: "json" })
        .done(function (cart) {
            $("body").removeClass("adding");
            var ssample_count = 0,
                travel_count = 0,
                giftKeyFromCart = [];
            cart.items.forEach((item) => {
                try {
                    if (item.properties && item.properties.__type) {
                        if (item.properties.__type === "free sample") {
                            ssample_count += item.quantity;
                        } else if (item.properties.__type === "free travel size") {
                            travel_count += item.quantity;
                        }
                    }
                } catch (err) {
                    console.log(err);
                }
            });
            var cart_total_price = cart.total_price / 100,
                checkItem = checkItemInCart(cart);
            console.log(
                ssample_count,
                "ssample_count>>>",
                parseInt(free_sample_id),
                parseInt(free_travel_id),
                travel_count,
                "travel_count>>>",free_travel_price
            );
            if (free_sample_id) {
                if (ssample_count == 0 && cart_total_price >= free_sample_price) {
                    console.log("Adding free sample");
                    $("body").addClass("adding");
                    addItemToCart({ quantity: 1, id: free_sample_id, properties: { __type: "free sample" } });
                } else if (ssample_count > 0 && cart_total_price < free_sample_price) {
                    removeItemInCart(cart, "free sample");
                }
            }
            if (free_travel_id) {
                if (travel_count == 0 && cart_total_price >= free_travel_price) {
                    console.log("Adding free travel size");
                    addItemToCart({ quantity: 1, id: free_travel_id, properties: { __type: "free travel size" } });
                } else if (travel_count > 0 && cart_total_price < free_travel_price) {
                    removeItemInCart(cart, "free travel size");
                } else if (travel_count > 1) {
                    removeItemInCart(cart, "free travel size");
                }
            }
        })
        .fail(function (xhr, textStatus, errorThrown) {
            console.error("Error fetching cart:", textStatus, errorThrown);
            $("body").removeClass("adding");
        });
}
function removeItemInCart(cart, __type = "") {
    let remove_items = cart.items.filter((item) => item.properties.__type === __type) || [];
    let to_remove = [];
    console.log(remove_items, "<<<< remove_items");
    if (remove_items.length) {
        remove_items.forEach((item) => {
            let quantity = 0;
            let item_key = item.key;
            to_remove.push(item_key + "|" + quantity);
        });
        console.log(to_remove, "<<<<< to_remove");
        removeSampleItemss(to_remove);
    }
}
window.onCartUpadate = () => {
    console.log("call window.onCartUpadate");
    validateFreeItems();
};
$(document).ready(function () {
    validateFreeItems();
});



var removeSampleItemss = (productIDS, callValidateFreeItem = "false") => {
  if (productIDS.length) {
    let formData = {
      updates: {},
    };

    var productID;
    for (productID in productIDS) {
      var id = productIDS[productID]?.split("|")[0];
      var qty = productIDS[productID]?.split("|")[1];
      formData["updates"][parseInt(id)] = qty;
    }
    console.log(formData);

    let info = fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then((response) => response.json())
      .then((data) => {
        if (callValidateFreeItem === "true") {
          validateFreeItems();
        } else {
          window.RefreshCartPage();
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }
};

window.RefreshCartPagePage  = async function() {
  $('[name="checkout"]').attr("disabled", 1);
  try {
    const mainCart = document.querySelector('main-cart');
    if (!mainCart) return;

    const sectionId = FoxTheme.utils.getSectionId(mainCart);

    const response = await fetch(
      `${FoxTheme.routes.root_url}?section_id=${sectionId}`
    );

    const html = await response.text();
    const parser = new DOMParser();
    const parsedHTML = parser.parseFromString(html, 'text/html');

    const updatedCart = parsedHTML.querySelector(`#MainCart-${sectionId}`);

    if (updatedCart) {
      document.querySelector(`#MainCart-${sectionId}`).innerHTML = updatedCart.innerHTML;
    }
    $('[name="checkout"]').attr("disabled", !1);

  } catch (error) {
    console.error('Cart refresh error:', error);
  }
};